import { render } from "./News.vue?vue&type=template&id=1540de33&scoped=true"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"

import "./News.vue?vue&type=style&index=0&id=1540de33&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1540de33"

export default script